import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelope,
  faBars,
  faTimes,
  faStore // Add this for fallback icon
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className="bg-gsmgreen text-white py-0.5 font-inter font-semibold">
        <div className="container mx-auto px-4 md:px-16">
          <div className="flex justify-between items-center">
            <div className="flex md:items-center md:space-x-4">
              <span className="text-sm whitespace-nowrap">
                <FontAwesomeIcon icon={faPhone} className="mr-1" /> +91 60333 60333
              </span>
              <span className="text-sm hidden md:inline">
                <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> customercare@gracesupermarket.com
              </span>
            </div>
            <div className="flex items-center">
              <span className="text-sm md:hidden">
                <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> customercare@gracesupermarket.com
              </span>
              <div className="hidden md:flex items-center space-x-4 ml-4">
                <Link to="/stores" className="text-sm hover:text-gray-200 ">Stores</Link>
                <div className="h-4 w-[2px] bg-white"></div>
                <div className="flex items-center space-x-3">
                  <Link to="https://www.facebook.com/graceonline.in/" className="hover:text-gray-200">
                    <FontAwesomeIcon icon={faFacebookF} size="sm" />
                  </Link>
                  <Link to="https://www.instagram.com/gracesupermarket/?hl=en" className="hover:text-gray-200">
                    <FontAwesomeIcon icon={faInstagram} size="sm" />
                  </Link>
                  <Link to="https://in.linkedin.com/company/grace-online-super-market" className="hover:text-gray-200">
                    <FontAwesomeIcon icon={faLinkedinIn} size="sm" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="bg-primary py-2 relative">
        <div className="container mx-auto px-4 md:px-16">
          <nav className="flex items-center justify-between">
            <Link to="/" className="flex-shrink-0">
              {logoError ? (
                <FontAwesomeIcon
                  icon={faStore}
                  className="h-8 md:h-10 w-8 md:w-10 text-white"
                />
              ) : (
                <img
                  src={logo}
                  alt="Grace Super Market"
                  onError={() => setLogoError(true)}
                />
              )}
            </Link>

            <div className="hidden md:flex items-center space-x-8 text-white">
              <Link to="/" className="hover:text-gray-200">Home</Link>
              <Link to="/about" className="hover:text-gray-200">About Us</Link>
              <Link to="/suppliers" className="hover:text-gray-200">Suppliers</Link>
              <Link to="/careers" className="hover:text-gray-200">Careers</Link>
              <Link to="/contact" className="hover:text-gray-200">Contact</Link>
            </div>

            <button
              className="md:hidden text-white focus:outline-none"
              onClick={toggleMenu}
            >
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} className="text-2xl" />
            </button>
          </nav>
        </div>

        {/* Mobile Menu */}
        <div className={`
          md:hidden fixed inset-0 bg-primary z-50 transform transition-transform duration-300 ease-in-out
          ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
        `}>
          <div className="container mx-auto px-4 py-6">
            <div className="flex justify-between items-center mb-8">
              <Link to="/" className="flex-shrink-0">
                <img src={logo} alt="Grace Super Market"  />
              </Link>
              <button
                className="text-white focus:outline-none"
                onClick={toggleMenu}
              >
                <FontAwesomeIcon icon={faTimes} className="text-2xl" />
              </button>
            </div>
            <div className="flex flex-col space-y-6">
              <Link
                to="/"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                About Us
              </Link>
              <Link
                to="/suppliers"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                Suppliers
              </Link>
              <Link
                to="/careers"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                Careers
              </Link>
              <Link
                to="/contact"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                Contact
              </Link>
              <Link
                to="/stores"
                className="text-white text-xl hover:text-gray-200"
                onClick={toggleMenu}
              >
                Stores
              </Link>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;